import {Suspense} from "react";
import {Router} from "react-router-dom";
import {renderRoutes} from "react-router-config";
import {Provider as StoreProvider} from "react-redux";
import {CircularProgress} from "@mui/material";
import configureStore from "./store/configureStore";
import routes from "./routes";
import {PersistGate} from "redux-persist/integration/react";
import {Worker} from "@react-pdf-viewer/core";
import history from "./browserHistory";

const {store, persistor} = configureStore();

function App() {
  return (
    <StoreProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router history={history}>
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
            <Suspense fallback={<CircularProgress color="secondary" />}>
              {renderRoutes(routes)}
            </Suspense>
          </Worker>
        </Router>
      </PersistGate>
    </StoreProvider>
  );
}

export default App;
